import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const Pricings = lazy(() => import('../../container/pricings'));
const Plans = lazy(() => import('../../container/pricings/plans'));

const Packages = lazy(() => import('../../container/pricings/packages'));
const AddPackage = lazy(() => import('../../container/pricings/packages/Add'));
const EditPackage = lazy(() => import('../../container/pricings/packages/Edit'));
const ViewPackage = lazy(() => import('../../container/pricings/packages/View'));

const PackageFeatures = lazy(() => import('../../container/pricings/package-features'));
const AddPackageFeature = lazy(() => import('../../container/pricings/package-features/Add'));
const EditPackageFeature = lazy(() => import('../../container/pricings/package-features/Edit'));
const ViewPackageFeature = lazy(() => import('../../container/pricings/package-features/View'));


function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/pricing-plans`} component={Pricings} />
      <Route exact path={`${path}/plans`} component={Plans} />

      <Route exact path={`${path}/packages`} component={Packages} />
      <Route exact path={`${path}/packages/add`} component={AddPackage} />
      <Route exact path={`${path}/packages/edit/:id`} component={EditPackage} />
      <Route exact path={`${path}/packages/view/:id`} component={ViewPackage} />

      <Route exact path={`${path}/package-features`} component={PackageFeatures} />
      <Route exact path={`${path}/package-features/add`} component={AddPackageFeature} />
      <Route exact path={`${path}/package-features/edit/:id`} component={EditPackageFeature} />
      <Route exact path={`${path}/package-features/view/:id`} component={ViewPackageFeature} />
    </Switch>
  );
}

export default PagesRoute;
